export function headerScroll() {
    const header = document.querySelector('[data-header]');
    const desktop = window.matchMedia('(min-width: 992px)');

    if (!header) return;

    let lastScroll = window.scrollY;

    window.addEventListener('scroll', () => {
        const currentScroll = window.scrollY;

        if (!desktop.matches || currentScroll < 99) {
            header.classList.remove('is-hidden');
            lastScroll = currentScroll;
            return;
        }

        header.classList.toggle('is-hidden', currentScroll > lastScroll);
        lastScroll = currentScroll;
    }, { passive: true });
}